import { Col, Row } from "antd";
import style from "./Footer.module.css";

export default function Footer() {
  const version = process.env.REACT_APP_VERSION || "v2.0.1";

  return (
    <Row
      className={style.Footer}
      justify="center"
      align="middle"
      gutter={[30, 15]}
    >
      <Col>
        <a href="https://22677957.hs-sites.com/en/bevz-help" target="_blank">
          FAQ
        </a>
      </Col>
      <Col>
        <a href="https://www.bevz.com/support" target="_blank">
          Support
        </a>
      </Col>
      <Col>
        <a href="https://www.bevz.com/terms-of-service" target="_blank">
          Terms of Service
        </a>
      </Col>
      <Col>
        <a href="https://www.bevz.com/privacy-policy" target="_blank">
          Privacy Policy
        </a>
      </Col>
      <Col>
        <a href="https://www.bevz.com/sitemap" target="_blank">
          &copy; 2025 Bevz {version}
        </a>
      </Col>
    </Row>
  );
}
